import axios from "axios";
import {
  throwSylaApiError,
  parseProblemFromBlob,
} from "../errors/throwSylaApiError";

export async function downloadTaxReportForFinancialYear(
  accountId: string,
  financialYearValue: string,
  reportName: string,
): Promise<void> {
  let blob: Blob;
  try {
    const response = await axios.get<Blob>(
      `/accounts/${accountId}/download-financial-year-pdf`,
      {
        params: { financialYearValue },
        responseType: "blob",
      },
    );
    blob = response.data;
  } catch (error) {
    throwSylaApiError(await parseProblemFromBlob(error));
  }

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute("download", `${reportName}.pdf`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
